"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _kubraKmap = _interopRequireDefault(require("kubra-kmap"));

var _actions = require("kmap-redux/dist/actions");

var _lodash = _interopRequireDefault(require("lodash"));

var _clusterIcon = _interopRequireDefault(require("../assets/cluster-icon.svg"));

var _BlueCircle = _interopRequireDefault(require("../assets/BlueCircle.svg"));

var _GreenPentagon = _interopRequireDefault(require("../assets/GreenPentagon.svg"));

var _PurpleTriangle = _interopRequireDefault(require("../assets/PurpleTriangle.svg"));

var _RedDiamond = _interopRequireDefault(require("../assets/RedDiamond.svg"));

var _YellowHexagon = _interopRequireDefault(require("../assets/YellowHexagon.svg"));

var _ManagedCluster = _interopRequireDefault(require("../assets/ManagedCluster.svg"));

var _CriticalCluster = _interopRequireDefault(require("../assets/CriticalCluster.svg"));

var _BothCluster = _interopRequireDefault(require("../assets/BothCluster.svg"));

var _ManagedBlueCircle = _interopRequireDefault(require("../assets/ManagedBlueCircle.svg"));

var _ManagedGreenPentagon = _interopRequireDefault(require("../assets/ManagedGreenPentagon.svg"));

var _ManagedPurpleTriangle = _interopRequireDefault(require("../assets/ManagedPurpleTriangle.svg"));

var _ManagedRedDiamond = _interopRequireDefault(require("../assets/ManagedRedDiamond.svg"));

var _ManagedYellowHexagon = _interopRequireDefault(require("../assets/ManagedYellowHexagon.svg"));

var _CriticalBlueCircle = _interopRequireDefault(require("../assets/CriticalBlueCircle.svg"));

var _CriticalGreenPentagon = _interopRequireDefault(require("../assets/CriticalGreenPentagon.svg"));

var _CriticalPurpleTriangle = _interopRequireDefault(require("../assets/CriticalPurpleTriangle.svg"));

var _CriticalRedDiamond = _interopRequireDefault(require("../assets/CriticalRedDiamond.svg"));

var _CriticalYellowHexagon = _interopRequireDefault(require("../assets/CriticalYellowHexagon.svg"));

var _BothBlueCircle = _interopRequireDefault(require("../assets/BothBlueCircle.svg"));

var _BothGreenPentagon = _interopRequireDefault(require("../assets/BothGreenPentagon.svg"));

var _BothPurpleTriangle = _interopRequireDefault(require("../assets/BothPurpleTriangle.svg"));

var _BothRedDiamond = _interopRequireDefault(require("../assets/BothRedDiamond.svg"));

var _BothYellowHexagon = _interopRequireDefault(require("../assets/BothYellowHexagon.svg"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var getRangeStyles = function getRangeStyles(layer) {
  var rangeStyles = layer.layerRangeStyle.map(function (layerRangeStyle) {
    if (layerRangeStyle.range && layerRangeStyle.range === 'cluster') {
      var _layerRangeStyle$icon, _layerRangeStyle$icon2;

      return [{
        rangeCriteria: [{
          field: 'cluster',
          condition: '=',
          value: true
        }, {
          field: 'n_out',
          condition: '<',
          value: 50
        }],
        rangeStyles: {
          icon: {
            url: (_layerRangeStyle$icon = layerRangeStyle.icon) === null || _layerRangeStyle$icon === void 0 ? void 0 : _layerRangeStyle$icon.url,
            size: layer.ignoreShape ? [0, 0] : [40, 40],
            anchor: [20, 20],
            // eslint-disable-next-line no-template-curly-in-string
            labelValue: '${n_out}',
            labelAnchor: [20, 21]
          },
          shape: null
        },
        rangeLegendIcon: null,
        rangeLabel: 'PointShelterEN',
        showInLegend: true
      }, {
        rangeCriteria: [{
          field: 'cluster',
          condition: '=',
          value: true
        }, {
          field: 'n_out',
          condition: '>=',
          value: 50
        }],
        rangeStyles: {
          icon: {
            url: (_layerRangeStyle$icon2 = layerRangeStyle.icon) === null || _layerRangeStyle$icon2 === void 0 ? void 0 : _layerRangeStyle$icon2.url,
            size: layer.ignoreShape ? [0, 0] : [40, 40],
            anchor: [20, 20],
            // eslint-disable-next-line no-template-curly-in-string
            labelValue: '50+',
            labelAnchor: [20, 21]
          },
          shape: null
        },
        rangeLegendIcon: null,
        rangeLabel: 'PointShelterEN',
        showInLegend: true
      }];
    }

    if (layerRangeStyle.range && layerRangeStyle.range.length === 2) {
      var _layerRangeStyle$icon3, _layerRangeStyle$shap, _layerRangeStyle$shap2, _layerRangeStyle$shap3, _layerRangeStyle$icon4, _layerRangeStyle$shap4, _layerRangeStyle$shap5, _layerRangeStyle$shap6;

      return [{
        rangeCriteria: [{
          field: 'cluster',
          condition: '!=',
          value: true
        }, {
          field: 'cust_a',
          condition: '>=',
          value: layerRangeStyle.range[0]
        }, {
          field: 'cust_a',
          condition: '<=',
          value: layerRangeStyle.range[1]
        } // layerRangeStyle.crew && { field: 'crew', condition: '=', value: true },
        ],
        rangeStyles: {
          icon: {
            url: (_layerRangeStyle$icon3 = layerRangeStyle.icon) === null || _layerRangeStyle$icon3 === void 0 ? void 0 : _layerRangeStyle$icon3.url,
            size: layer.ignoreShape ? [0, 0] : [25, 25],
            anchor: [12, 12],
            // eslint-disable-next-line no-template-curly-in-string
            labelValue: '',
            labelAnchor: [20, 21]
          },
          shape: {
            borderColor: ((_layerRangeStyle$shap = layerRangeStyle.shape) === null || _layerRangeStyle$shap === void 0 ? void 0 : _layerRangeStyle$shap.borderColor) || ((_layerRangeStyle$shap2 = layerRangeStyle.shape) === null || _layerRangeStyle$shap2 === void 0 ? void 0 : _layerRangeStyle$shap2.fillColor),
            borderOpacity: 0.4,
            borderWeight: 1,
            fillColor: (_layerRangeStyle$shap3 = layerRangeStyle.shape) === null || _layerRangeStyle$shap3 === void 0 ? void 0 : _layerRangeStyle$shap3.fillColor,
            opacity: 0.4
          }
        },
        rangeLegendIcon: null,
        rangeLabel: 'PointShelterEN',
        showInLegend: true
      }, layerRangeStyle.crew && {
        rangeCriteria: [{
          field: 'cluster',
          condition: '!=',
          value: true
        }, {
          field: 'cust_a',
          condition: '>=',
          value: layerRangeStyle.range[0]
        }, {
          field: 'cust_a',
          condition: '<=',
          value: layerRangeStyle.range[1]
        }, {
          field: 'crew',
          condition: '=',
          value: false
        }],
        rangeStyles: {
          icon: {
            url: (_layerRangeStyle$icon4 = layerRangeStyle.icon) === null || _layerRangeStyle$icon4 === void 0 ? void 0 : _layerRangeStyle$icon4.url,
            size: layer.ignoreShape ? [0, 0] : [25, 25],
            anchor: [12, 12],
            // eslint-disable-next-line no-template-curly-in-string
            labelValue: '',
            labelAnchor: [20, 21]
          },
          shape: {
            borderColor: ((_layerRangeStyle$shap4 = layerRangeStyle.shape) === null || _layerRangeStyle$shap4 === void 0 ? void 0 : _layerRangeStyle$shap4.borderColor) || ((_layerRangeStyle$shap5 = layerRangeStyle.shape) === null || _layerRangeStyle$shap5 === void 0 ? void 0 : _layerRangeStyle$shap5.fillColor),
            borderOpacity: 0.4,
            borderWeight: 1,
            fillColor: (_layerRangeStyle$shap6 = layerRangeStyle.shape) === null || _layerRangeStyle$shap6 === void 0 ? void 0 : _layerRangeStyle$shap6.fillColor,
            opacity: 0.4
          }
        },
        rangeLegendIcon: null,
        rangeLabel: 'PointShelterEN',
        showInLegend: true
      }];
    }

    if (layerRangeStyle.range && layerRangeStyle.range.length === 1) {
      var _layerRangeStyle$icon5, _layerRangeStyle$shap7, _layerRangeStyle$shap8, _layerRangeStyle$shap9, _layerRangeStyle$icon6, _layerRangeStyle$shap10, _layerRangeStyle$shap11, _layerRangeStyle$shap12;

      return [{
        rangeCriteria: [{
          field: 'cluster',
          condition: '!=',
          value: true
        }, {
          field: 'cust_a',
          condition: '>=',
          value: layerRangeStyle.range[0]
        } // layerRangeStyle.crew && { field: 'crew', condition: '=', value: true },
        ],
        rangeStyles: {
          icon: {
            url: (_layerRangeStyle$icon5 = layerRangeStyle.icon) === null || _layerRangeStyle$icon5 === void 0 ? void 0 : _layerRangeStyle$icon5.url,
            size: layer.ignoreShape ? [0, 0] : [25, 25],
            anchor: [12, 12],
            // eslint-disable-next-line no-template-curly-in-string
            labelValue: '',
            labelAnchor: [20, 21]
          },
          shape: {
            borderColor: ((_layerRangeStyle$shap7 = layerRangeStyle.shape) === null || _layerRangeStyle$shap7 === void 0 ? void 0 : _layerRangeStyle$shap7.borderColor) || ((_layerRangeStyle$shap8 = layerRangeStyle.shape) === null || _layerRangeStyle$shap8 === void 0 ? void 0 : _layerRangeStyle$shap8.fillColor),
            borderOpacity: 0.4,
            borderWeight: 1,
            fillColor: (_layerRangeStyle$shap9 = layerRangeStyle.shape) === null || _layerRangeStyle$shap9 === void 0 ? void 0 : _layerRangeStyle$shap9.fillColor,
            opacity: 0.4
          }
        },
        rangeLegendIcon: null,
        rangeLabel: 'PointShelterEN',
        showInLegend: true
      }, layerRangeStyle.crew && {
        rangeCriteria: [{
          field: 'cluster',
          condition: '!=',
          value: true
        }, {
          field: 'cust_a',
          condition: '>=',
          value: layerRangeStyle.range[0]
        }, {
          field: 'crew',
          condition: '=',
          value: false
        }],
        rangeStyles: {
          icon: {
            url: (_layerRangeStyle$icon6 = layerRangeStyle.icon) === null || _layerRangeStyle$icon6 === void 0 ? void 0 : _layerRangeStyle$icon6.url,
            size: layer.ignoreShape ? [0, 0] : [25, 25],
            anchor: [12, 12],
            // eslint-disable-next-line no-template-curly-in-string
            labelValue: '',
            labelAnchor: [20, 21]
          },
          shape: {
            borderColor: ((_layerRangeStyle$shap10 = layerRangeStyle.shape) === null || _layerRangeStyle$shap10 === void 0 ? void 0 : _layerRangeStyle$shap10.borderColor) || ((_layerRangeStyle$shap11 = layerRangeStyle.shape) === null || _layerRangeStyle$shap11 === void 0 ? void 0 : _layerRangeStyle$shap11.fillColor),
            borderOpacity: 0.4,
            borderWeight: 1,
            fillColor: (_layerRangeStyle$shap12 = layerRangeStyle.shape) === null || _layerRangeStyle$shap12 === void 0 ? void 0 : _layerRangeStyle$shap12.fillColor,
            opacity: 0.4
          }
        },
        rangeLegendIcon: null,
        rangeLabel: 'PointShelterEN',
        showInLegend: true
      }];
    }

    return [];
  }).flat().filter(function (value) {
    return value !== undefined;
  });
  return rangeStyles;
};

var getManagedIcon = function getManagedIcon(icon) {
  switch (icon) {
    case _clusterIcon.default:
      return _ManagedCluster.default;

    case _BlueCircle.default:
      return _ManagedBlueCircle.default;

    case _GreenPentagon.default:
      return _ManagedGreenPentagon.default;

    case _PurpleTriangle.default:
      return _ManagedPurpleTriangle.default;

    case _RedDiamond.default:
      return _ManagedRedDiamond.default;

    case _YellowHexagon.default:
      return _ManagedYellowHexagon.default;

    default:
      return icon;
  }
};

var getCriticalIcon = function getCriticalIcon(icon) {
  switch (icon) {
    case _clusterIcon.default:
      return _CriticalCluster.default;

    case _BlueCircle.default:
      return _CriticalBlueCircle.default;

    case _GreenPentagon.default:
      return _CriticalGreenPentagon.default;

    case _PurpleTriangle.default:
      return _CriticalPurpleTriangle.default;

    case _RedDiamond.default:
      return _CriticalRedDiamond.default;

    case _YellowHexagon.default:
      return _CriticalYellowHexagon.default;

    default:
      return icon;
  }
};

var getBothIcon = function getBothIcon(icon) {
  switch (icon) {
    case _clusterIcon.default:
      return _BothCluster.default;

    case _BlueCircle.default:
      return _BothBlueCircle.default;

    case _GreenPentagon.default:
      return _BothGreenPentagon.default;

    case _PurpleTriangle.default:
      return _BothPurpleTriangle.default;

    case _RedDiamond.default:
      return _BothRedDiamond.default;

    case _YellowHexagon.default:
      return _BothYellowHexagon.default;

    default:
      return icon;
  }
};

var isCluster = function isCluster(rangeCriteria) {
  return rangeCriteria.reduce(function (previousValue, currentValue) {
    return previousValue || currentValue.field === 'cluster' && currentValue.condition === '=' && currentValue.value === true;
  }, false).valueOf();
};

var createRange = function createRange(rangeStyle, iconGetter, accountType) {
  var newRangeStyle = _lodash.default.cloneDeep(rangeStyle);

  var cluster = isCluster(newRangeStyle.rangeCriteria);
  var sizeToAdd = cluster ? [3.5, 0] : [7, 3.5];
  newRangeStyle.rangeCriteria.push({
    field: 'account_type',
    condition: '=',
    value: accountType
  });
  newRangeStyle.rangeStyles.icon.url = iconGetter(newRangeStyle.rangeStyles.icon.url);
  newRangeStyle.rangeStyles.icon.size = [rangeStyle.rangeStyles.icon.size[0] + sizeToAdd[0], rangeStyle.rangeStyles.icon.size[1] + sizeToAdd[1]];
  newRangeStyle.rangeStyles.icon.anchor = [rangeStyle.rangeStyles.icon.anchor[0], rangeStyle.rangeStyles.icon.anchor[1]];
  return newRangeStyle;
};

var getOutageRanges = function getOutageRanges(layer) {
  var ranges = getRangeStyles(layer);
  var outageRanges = [];
  ranges.forEach(function (rangeStyle) {
    if (['outages', 'managed_outages'].includes(layer.layerName)) {
      outageRanges.push(createRange(rangeStyle, getManagedIcon, 'LCS'));
    }

    if (['outages', 'outages_lite', 'critical_outages'].includes(layer.layerName)) {
      outageRanges.push(createRange(rangeStyle, getCriticalIcon, 'JOC'));
    }

    if (['outages', 'both_outages'].includes(layer.layerName)) {
      outageRanges.push(createRange(rangeStyle, getBothIcon, 'BOTH'));
    }

    outageRanges.push(rangeStyle);
  });
  return outageRanges;
};

var getTFRanges = function getTFRanges(layer) {
  var ranges = layer.layerRangeStyle;
  var tfRanges = [];
  ranges.forEach(function (rangeStyle) {
    if (rangeStyle.range === 'cluster') {
      var _rangeStyle$icon;

      tfRanges.push({
        rangeCriteria: [{
          field: 'cluster',
          condition: '=',
          value: true
        }],
        rangeStyles: {
          icon: {
            url: (_rangeStyle$icon = rangeStyle.icon) === null || _rangeStyle$icon === void 0 ? void 0 : _rangeStyle$icon.url,
            size: layer.ignoreShape ? [0, 0] : [25, 25],
            anchor: [12, 12],
            // eslint-disable-next-line no-template-curly-in-string
            labelValue: '',
            labelAnchor: [20, 21]
          },
          shape: null
        },
        rangeLegendIcon: null,
        rangeLabel: 'PointShelterEN',
        showInLegend: true
      });
    } else if (rangeStyle.range) {
      var _rangeStyle$icon2;

      tfRanges.push({
        rangeCriteria: [{
          field: 'cluster',
          condition: '=',
          value: false
        }, {
          field: 'type',
          condition: '=',
          value: rangeStyle.range
        }],
        rangeStyles: {
          icon: {
            url: (_rangeStyle$icon2 = rangeStyle.icon) === null || _rangeStyle$icon2 === void 0 ? void 0 : _rangeStyle$icon2.url,
            size: layer.ignoreShape ? [0, 0] : [25, 25],
            anchor: [12, 12],
            // eslint-disable-next-line no-template-curly-in-string
            labelValue: '',
            labelAnchor: [20, 21]
          },
          shape: null
        },
        rangeLegendIcon: null,
        rangeLabel: 'PointShelterEN',
        showInLegend: true
      });
    }
  });
  return tfRanges;
};

var mapLayersConfig = function mapLayersConfig(layerConfigs, metadata) {
  return layerConfigs.map(function (layer) {
    var layerRanges = [];

    if (layer.layerName.includes('outage')) {
      layerRanges = getOutageRanges(layer);
    } else if (layer.layerName.includes('tf')) {
      layerRanges = getTFRanges(layer);
    } else {
      layerRanges = getRangeStyles(layer);
    }

    var layerConfig = {
      type: _kubraKmap.default.layerType.VECTOR,
      format: _kubraKmap.default.layerFormat.JSON,
      compress: true,
      zIndex: 200,
      showMarker: layer.ignoreMarker ? _kubraKmap.default.layerShowMarker.NEVER : _kubraKmap.default.layerShowMarker.ALWAYS,
      showShape: layer.ignoreShape ? _kubraKmap.default.layerShowShape.NEVER : _kubraKmap.default.layerShowShape.ALWAYS,
      clickable: true,
      visible: false,
      style: {
        ranges: layerRanges
      }
    };
    return (0, _actions.loadLayer)(layer.layerName, [layer.source(metadata)], layerConfig);
  });
};

var _default = mapLayersConfig;
exports.default = _default;